import React from 'react'

import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useSetRecoilState } from 'recoil'

import styled from '@emotion/styled'

import { contentPositionState } from '../recoil/state'

import svgload from 'Helpers/svgload'

import IconCheck from 'mailup-web-components/src/img/icons/check.svg?raw'

const ItemPreviewContainer = styled.div`
  position: absolute;
  background-color: var(--mine-shaft);
  opacity: 0.9;
  top: -2px;
  left: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  padding: 8px;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
`

const ItemPreviewWrapper = styled.div`
  max-width: 100%;

  &::before {
    content: '';
    margin-bottom: 20px;
    height: 20px;
    width: 20px;
    border-radius: 10px;
    background-color: #c5e7b0;
    color: #59af26;

    display: block;

    background-image: ${svgload(IconCheck, { path: { fill: '#59af26' } })};
    background-size: 13px;
    background-position: 3px 4px;
    background-repeat: no-repeat;
  }
`

const ItemPreviewTitle = styled.p`
  color: #fff;
  font-size: 12px;
  margin: 0 0 4px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const ItemPreviewCancel = styled.a`
  color: var(--java);
  font-size: 12px;
  font-weight: 500;

  &:hover {
    color: var(--java);
  }
`

export const ContentsPreviewItem = ({ position, contentKey, title }) => {
  const intl = useIntl()

  const changePosition = useSetRecoilState(contentPositionState(contentKey))

  const handleCancel = () => changePosition(0)

  if (!contentKey) return null

  return (
    <ItemPreviewContainer>
      <ItemPreviewWrapper>
        <ItemPreviewTitle>{title}</ItemPreviewTitle>

        <ItemPreviewCancel onClick={handleCancel}>
          {intl.formatMessage({
            id: 'Load.BeeContentDialog.CancelSelection'
          })}
        </ItemPreviewCancel>
      </ItemPreviewWrapper>
    </ItemPreviewContainer>
  )
}

ContentsPreviewItem.propTypes = {
  position: PropTypes.number.isRequired,
  contentKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default ContentsPreviewItem
